import type { Kind } from './close';

/** Oversikt handles ended open punches individually. Its aggregate lists exclude those records. */
export const WORKLISTS = {
  'prev-month': 'Ikke godkjent fra forrige måned',
  missing: 'Vakter uten stempling',
  deviation: 'Vakter med avvik fra plan',
  ready: 'Vakter klare til godkjenning',
} as const;
export type Worklist = keyof typeof WORKLISTS;
export const worklistOf = (key: string | null): Worklist | null =>
  key != null && Object.hasOwn(WORKLISTS, key) ? (key as Worklist) : null;
export const inWorklist = (key: Worklist, kind: Kind) =>
  key === 'prev-month' ? kind === 'missing' || kind === 'deviation' || kind === 'ready' : kind === key;
